export enum EFarmSlotTypes {
FIELDS = "fields",
FARM = "farm",
FACTORY = "factory",
}